import {Link} from "@/components/atoms/link";
import {Button} from "@/components/atoms/button";
import {resolveHashElement} from "@/lib/hash-aliases";

export function ParagraphButton({paragraph, ...props}) {
  const buttons = paragraph?.field_button_link;
  const btnAlignment = paragraph?.field_button_alignment ?? "btn_left";
  const btnLayout = paragraph?.field_button_layout ?? "btn_wrap";

  if (!buttons || !Array.isArray(buttons) || buttons.length === 0) return <></>;

  return (
    <div
      className={`paragraph--button component-button pb-6 ${btnAlignment === "btn_left" ? 'text-left' : btnAlignment === "btn_right" ? 'text-right' : btnAlignment === "btn_center" ? 'text-center' : 'text-left'} `}>
      {buttons.map((button, index) => (
        <>
          {button?.url?.startsWith('#') && (
            <Button
              key={`${paragraph?.id}--button--${index}`}
              href={button.url}
              callback={(event) => {
                  event.preventDefault();
                  const element = resolveHashElement(button.url);
                  if (element) element.scrollIntoView({behavior: 'smooth'})
              }}
              className="max-md:w-full"
              containerClassName="max-md:w-full"
              color="primary" hover={{color: "primary"}} position="right">{button?.title}</Button>
          )}
          {!button?.url.startsWith('#') && (
            <Link key={index}
                  href={button?.url}
                  className={`${btnLayout === "btn_wrap" ? '' : btnLayout === "btn_stacked" ? 'w-full' : ''} py-2 px-3 border-2 font-bold rounded-sm inline-flex flex-row items-center justify-center transition-all duration-500 border-primary bg-primary text-white hover:border-2 hover:border-primary hover:text-primary hover:bg-white max-md:w-full ${buttons.length === 1 ? '' : 'mr-3 mb-3'}`}>
              {button?.title}
            </Link>
          )}
        </>
      ))}
    </div>
  );
}
